<template>
  <div class="Columns">
    <slot />
  </div>
</template>

<script>
import './style.scss'

export default {
  name: 'Columns',
}
</script>
